/* eslint-disable react/no-danger */
import React from 'react';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/core/styles';

let popOverFn;
let popOverCloseFn;

const styles = theme => ({
  popover: {
    pointerEvents: 'none'
  },
  paper: {
    padding: theme.spacing(1)
  }
});

class PopOver extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      message: ''
    }
  }

  componentDidMount() {
    popOverFn = this.openPopOver;
    popOverCloseFn = this.popOverClose;
  }

  openPopOver = ({ elem, message }) => {
    this.setState({
      anchorEl: elem,
      message
    });
  };

  popOverClose = () => {
    this.setState({
      anchorEl: null,
      message: null
    });
  };

  handlePopoverClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes } = this.props;
    const { anchorEl, message } = this.state;
    const open = Boolean(anchorEl);
    return (
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        onClose={this.handlePopoverClose}
        disableRestoreFocus
      >
      {message && <div dangerouslySetInnerHTML={{ __html: message }} />}
      </Popover>
    );
  }
}

export function openPopOver({ elem, message }) {
  popOverFn({ elem, message });
}
export function closePopOver() {
  popOverCloseFn();
}

export default withStyles(styles)(PopOver);
